import {
  isRequired,
  isFieldInArray,
  isRequiredCurrency
} from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.daysArray && values.daysArray.length) {
    const daysArray = values.daysArray;
    const daysArrayErrors = [];

    daysArray.forEach((day, dayIndex) => {
      const daysErrors = {};

      const categoryArrayErrors = [];

      day.categories.forEach((category, categoryIndex) => {
        const categoryErrors = {};

        if (isRequired(category.participant || '', true)) {
          categoryErrors['participant'] = 'Category is required';
          categoryArrayErrors[categoryIndex] = categoryErrors;
        } else if (
          isFieldInArray(category.participant, day.categories, 'participant')
        ) {
          categoryErrors['participant'] = 'Category already exists';
          categoryArrayErrors[categoryIndex] = categoryErrors;
        }

        if (isRequiredCurrency(category)) {
          categoryErrors['USD'] = 'Error';
          categoryErrors['EUR'] = 'Error';
          categoryErrors['NOK'] = 'Error';
          categoryArrayErrors['_error'] = {
            ...categoryArrayErrors['_error'],
            [categoryIndex]:
              'Value for at least one currency for each category should be filled in'
          };
          categoryArrayErrors[categoryIndex] = categoryErrors;
        }
      });

      if (categoryArrayErrors.length || categoryArrayErrors['_error']) {
        daysErrors['categories'] = categoryArrayErrors;
        daysArrayErrors[dayIndex] = daysErrors;
      }
    });

    if (daysArrayErrors.length) {
      errors.daysArray = daysArrayErrors;
      errors.daysArray = { ...daysArrayErrors, _error: { ...daysArrayErrors } };
    }
  }

  return errors;
};

export default validate;
